// 9fbef606107a605d69c0edbcd8029e5d
import { getPlaceSiteId } from '@tcp/core/src/utils';
import { executeStatefulAPICall } from '../../../handler';
import endpoints from '../../../endpoints';
/**
 * Abstractor to pass the email id for resending order confirmation
 */
const Abstractor = {
  /**
   * @param {Object} reqBody body to the API
   * @return {Object} return promise.
   */
  sendOrderEmail: (reqBody) => {
    const reqObj = {
      header: { siteId: getPlaceSiteId() },
      webService: endpoints.sendOrderEmail,
      body: {
        ...reqBody,
      },
    };

    return executeStatefulAPICall(reqObj)
      .then(Abstractor.processSubscriptionData)
      .catch(Abstractor.handleSubscriptionError);
  },
  /**
   * @param {Object} res response object
   * @return {Object} returns response object.
   */
  processSubscriptionData: (res) => {
    return res.body.response || res.body;
  },
  handleSubscriptionError: (res) => {
    return res?.errorResponse?.errors && res.errorResponse.errors.length > 0
      ? res.errorResponse.errors[0]
      : {};
  },
};
export default Abstractor;
